import {
	applyCaptivePortalFilter,
	focusCaptivePortal,
	highlightCaptivePortalBulkDelete,
	openCaptivePortalSection,
	refreshCaptivePortals,
} from './adapter';
import {
	openCaptivePortalCreateModal,
	openCaptivePortalDeleteModal,
	openCaptivePortalEditModal,
	openCaptivePortalVoucherModal,
} from './modal';
import {resolveCaptivePortals} from './resolver';

/**
 * Captive Portals.
 *
 * The list on IO-Pass Configuration, and a record collection in its own
 * right: Canvas names the whole page "io Pass Captive Portal", so a captive
 * portal and IO-Pass are one feature rather than two. Each row is a portal a
 * guest is shown before being let onto the network.
 *
 * Every control the list offers has a way in: Add, Refresh, the search box
 * and the bulk Delete on the accordion, and Edit, Delete and Generate
 * Voucher on each row. The three row actions end at a form - the agent
 * opens it and a person fills it in, which is where open-only stops.
 */
const captivePortalPlugin = {
	id: 'captive_portal',
	version: 1,
	commandVersion: 1,
	resource: 'captive_portal',
	operations: [
		'options',
		'view',
		'search',
		'create',
		'edit',
		'delete',
		'generate_voucher',
		'bulk_delete',
		'refresh',
	],
	dependencies: {
		plugins: ['canvas.navigation', 'guest_config'],
		destinations: ['iopass.dashboard'],
	},
	sections: {
		'iopass.captive_portals': (command) => {
			if (command?.params?.action_target === 'delete') {
				return highlightCaptivePortalBulkDelete(command);
			}
			return openCaptivePortalSection();
		},
	},
	resolvers: {
		captive_portal: resolveCaptivePortals,
	},
	filters: {
		captive_portal: applyCaptivePortalFilter,
	},
	focusHandlers: {
		captive_portal: focusCaptivePortal,
	},
	modals: {
		'captive_portal.create': openCaptivePortalCreateModal,
		'captive_portal.edit': openCaptivePortalEditModal,
		'captive_portal.delete': openCaptivePortalDeleteModal,
		'captive_portal.generate_voucher': openCaptivePortalVoucherModal,
	},
	refreshHandlers: {
		captive_portal: refreshCaptivePortals,
	},
};

export default captivePortalPlugin;
